import { BaseSidebarObject, getPointString } from '@y42/gojs';
import {
  DataModelGitGoJSLink,
  DataModelGitGoJSNode,
  TransformationTypesEnum,
  UiModelingModelSettings,
} from '@y42/json-schema';
import * as go from 'gojs';
import { TransformationStepModel } from './transformation-type.model';

export const NON_GROUP_TYPES = [TransformationTypesEnum.Sticky, TransformationTypesEnum.Attention];

export enum DataModelNodeErrorType {
  NotConnected = 'NOT_CONNECTED',
  InvalidParent = 'INVALID_PARENT',
  Normal = 'NORMAL',
  Monaco = 'MONACO',
  Backend = 'BACKEND',
}

export const DataModelNodeErrorPriorities = {
  NOT_CONNECTED: 0,
  INVALID_PARENT: 1,
  BACKEND: 2,
  MONACO: 3,
  NORMAL: 4,
};

export interface DataModelNodeError {
  key: string;
  message: string;
  type: DataModelNodeErrorType;
}

export interface DataModelGoJSLink extends DataModelGitGoJSLink {}

export const createDataModelGoJSNode = (step: TransformationStepModel, location?: go.Point): DataModelGoJSNode => ({
  key: step.id,
  type: step.transformationType,
  category: step.transformationType || '',
  transformationStep: step,
  errors: [],
  isGroup: step.transformationType ? !NON_GROUP_TYPES.includes(step.transformationType) : true,
  group: '',
  location: location ? getPointString(location.x, location.y) : getPointString(0, 0),
});

export enum ModelingBuildStatus {
  UNTOUCHED = 'UNTOUCHED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  READY = 'READY',
}

export interface DataModelGoJSNode extends DataModelGitGoJSNode {
  transformationStep: TransformationStepModel;
  errors?: DataModelNodeError[];
  status?: {
    status: ModelingBuildStatus;
    externalUrl: string;
  };
  loc?: go.Point;
}

export interface DataModelGoJSModel extends UiModelingModelSettings {
  class: string;
  nodeCategoryProperty: string;
  linkFromPortIdProperty: string;
  linkToPortIdProperty: string;
  modelData?: object;
  nodeDataArray: Array<DataModelGoJSNode | BaseSidebarObject>;
  linkDataArray: Array<DataModelGoJSLink | BaseSidebarObject>;
}

export const createDefaultGojsModel = (): DataModelGoJSModel => ({
  class: 'go.GraphLinksModel',
  nodeCategoryProperty: 'category',
  linkFromPortIdProperty: 'frompid',
  linkToPortIdProperty: 'topid',
  nodeDataArray: [],
  linkDataArray: [],
});

export interface DownloadSQLModel {
  sql: string;
  params: string[];
}
